import React from 'react';
import { Modal, Space, Typography, Button, Divider } from 'antd';
import { FileTextOutlined, PrinterOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const TicketDetalleVentaFactura = ({ isOpen, onClose, venta, onPrint }) => {
    if (!venta) return null;

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        return new Date(fecha).toLocaleString('es-CO', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit', hour12: true
        });
    };

    let itemsSeguros = [];
    if (Array.isArray(venta.productos)) itemsSeguros = venta.productos;
    else if (typeof venta.productos === 'string') {
        try { itemsSeguros = JSON.parse(venta.productos); } catch (e) { itemsSeguros = []; }
    } else if (Array.isArray(venta.detalle)) itemsSeguros = venta.detalle;
    else if (Array.isArray(venta.items)) itemsSeguros = venta.items;

    let sumaSubtotal = 0;
    let sumaDescuentos = 0;
    
    itemsSeguros.forEach(item => {
        const precioBase = Number(item.precio_unitario || item.precio || 0);
        const cantidad = Number(item.cantidad || 1);
        const porcentajeDescuento = Number(item.descuento || 0);
        const subtotalItem = precioBase * cantidad;
        const ahorroItem = subtotalItem * (porcentajeDescuento / 100);
        sumaSubtotal += subtotalItem;
        sumaDescuentos += ahorroItem;
    });

    const mathModal = { subtotal: sumaSubtotal, descuento: Math.round(sumaDescuentos) };
    const metodoPago = (venta.metodo_pago || '').toLowerCase();

    return (
        <Modal
            title={<Space><FileTextOutlined style={{ color: '#22BABB' }} /><Text strong>DETALLE DE VENTA</Text></Space>}
            open={isOpen}
            onCancel={onClose}
            width={400}
            centered
            footer={[
                <Button key="print" type="primary" block icon={<PrinterOutlined />} onClick={() => onPrint && onPrint(venta)} style={{ background: '#22BABB', height: '45px', fontWeight: 'bold' }}>
                    REIMPRIMIR DOCUMENTO
                </Button>
            ]}
            styles={{ body: { padding: 0 } }}
        >
            <style>{`
                .ticket-scroll::-webkit-scrollbar { width: 4px; }
                .ticket-scroll::-webkit-scrollbar-thumb { background-color: #cbd5e1; border-radius: 4px; }
            `}</style>

            <div style={{ padding: '25px', backgroundColor: '#fff', fontFamily: 'monospace', height: 'calc(100vh - 150px)' }}>
                <div style={{ textAlign: 'center', marginBottom: 15 }}>
                    <Title level={5} style={{ margin: 0 }}>
                        {venta.numero_factura ? `RECIBO #${venta.numero_factura}` : (venta.id ? `RECIBO #${String(venta.id).slice(0, 8).toUpperCase()}` : 'TICKET DE VENTA')}
                    </Title>
                    <Text style={{ fontSize: '11px' }}>{formatearFecha(venta.fecha)}</Text>
                </div>
                <Divider dashed style={{ margin: '10px 0' }} />
                <div style={{ fontSize: '12px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '600' }}><Text>CAJERO:</Text><Text>{venta.cajero_nombre?.toUpperCase() || 'CAJERO'} {venta.cajero_apellidos?.toUpperCase() || ''}</Text></div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '600' }}><Text>CLIENTE:</Text><Text>{venta.cliente_nombre?.toUpperCase() || 'CONSUMIDOR FINAL'}</Text></div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '600' }}><Text>CC/NIT:</Text><Text>{venta.cliente_documento || '222222222222'}</Text></div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '600' }}><Text>MEDIO DE PAGO:</Text><Text>{venta.metodo_pago?.toUpperCase() || 'NO REGISTRADO'}</Text></div>
                </div>
                
                <Divider dashed style={{ margin: '10px 0' }} />
                
                <div className="ticket-scroll" style={{ marginBottom: 15, maxHeight: '220px', overflowY: 'auto', paddingRight: '8px' }}>
                    {itemsSeguros.map((item, i) => (
                        <div key={i} style={{ marginBottom: 8, fontSize: '12px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span style={{ flex: 1 }}>{item.nombre?.toUpperCase()}</span>
                                <Text strong>${Number(item.subtotal || (Number(item.precio_unitario || item.precio || 0) * Number(item.cantidad || 1))).toLocaleString('es-CO')}</Text>
                            </div>
                            <div style={{ fontSize: '11px', color: '#666' }}>{item.cantidad} UND x ${Number(item.precio_unitario || item.precio).toLocaleString('es-CO')}</div>
                        </div>
                    ))}
                </div>
                
                <Divider dashed style={{ margin: '10px 0' }} />
                
                <div style={{ fontSize: '13px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}><Text>SUBTOTAL:</Text><Text>${mathModal.subtotal.toLocaleString('es-CO')}</Text></div>
                    {mathModal.descuento > 0 && <div style={{ display: 'flex', justifyContent: 'space-between', color: '#16a34a' }}><Text>DCTO:</Text><Text>-${mathModal.descuento.toLocaleString('es-CO')}</Text></div>}

                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: metodoPago === 'credito' ? '15px' : '18px', fontWeight: 'bold', marginTop: 5 }}>
                        <span>TOTAL VENTA:</span><span>${Number(venta.total).toLocaleString('es-CO')}</span>
                    </div>
                </div>
                <Divider dashed style={{ margin: '10px 0' }} />
                <div style={{ background: '#f8fafc', padding: '10px', borderRadius: '4px', fontSize: '11px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}><Text strong>MÉTODO:</Text><Text>{venta.metodo_pago?.toUpperCase()}</Text></div>
                    {metodoPago === 'efectivo' && (
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}><Text>RECIBIDO:</Text><Text>${Number(venta.efectivo_recibido || 0).toLocaleString('es-CO')}</Text></div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}><Text>CAMBIO:</Text><Text strong>${Number(venta.cambio_entregado || 0).toLocaleString('es-CO')}</Text></div>
                        </>
                    )}
                    {metodoPago === 'mixto' && (
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}><Text>EFECTIVO:</Text><Text>${Number(venta.monto_efectivo || 0).toLocaleString('es-CO')}</Text></div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}><Text>TRANSF.:</Text><Text>${Number(venta.monto_transferencia || 0).toLocaleString('es-CO')}</Text></div>
                        </>
                    )}
                    {metodoPago === 'credito' && (
                        <div style={{ marginTop: '8px', borderTop: '1px dashed #cbd5e1', paddingTop: '8px' }}>
                            {Number(venta.efectivo_recibido) > 0 && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                                    <Text>ABONO INICIAL:</Text>
                                    <Text>${Number(venta.efectivo_recibido).toLocaleString('es-CO')}</Text>
                                </div>
                            )}
                            <div style={{ display: 'flex', justifyContent: 'space-between', color: '#cf1322', fontSize: '16px', background: '#fef2f2', padding: '4px', borderRadius: '4px' }}>
                                <Text strong style={{ color: '#cf1322' }}>SALDO PENDIENTE:</Text>
                                <Text strong style={{ color: '#cf1322' }}>
                                    ${Number((venta.total || 0) - (venta.efectivo_recibido || 0)).toLocaleString('es-CO')}
                                </Text>
                            </div>
                        </div>
                    )}
                </div>
                <div style={{ textAlign: 'center', marginTop: 15, fontSize: '10px', color: '#999' }}>*** YUGONUB POS - GRACIAS ***</div>
            </div>
        </Modal>
    );
};

export default TicketDetalleVentaFactura;